export default __webpack_public_path__ + "static/susan-schmidt-cutout-fc32388cc58780defe6a1988c19e6695.webp";